import theme from 'shared/assets/style/theme';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import defaultTheme from './defaultTheme';
import { isTablet, isMobile, isAndroid } from 'react-device-detect';
import { pwaStyleAdapter, isNotStandaloneMobilePWA, isStandalonePWA } from '../utils/mobileSupported';

const windowWidth = window.innerWidth;
const windowHeight = window.innerHeight;

const LadyluckTheme = {
  ...defaultTheme,
  AutoFormInput: {
    ...defaultTheme.AutoFormInput,
    FormOptions: {
      ...defaultTheme.AutoFormInput.FormOptions,
      color: theme.palette.common[1],
      backgroundColor: theme.palette.primary[32],
    },
  },
  LimitedTimeOffer: {
    ...defaultTheme.LimitedTimeOffer,
    BannerContainer: {
      ...defaultTheme.LimitedTimeOffer.BannerContainer,
      marginBottom: '1.5%',
    },
    StarIcon: {
      ...defaultTheme.LimitedTimeOffer.StarIcon,
      width: '16%',
    },
    BuyButton: {
      ...defaultTheme.LimitedTimeOffer.BuyButton,
      left: 'calc(50% - 85px)',
    },
    MainContainer: {
      ...defaultTheme.LimitedTimeOffer.MainContainer,
      marginBottom: '0.2%',
      height: '23%',
    },
  },
  LobbyOverlay: {
    ...defaultTheme.LobbyOverlay,
    MainSceneContainer: {
      ...defaultTheme.LobbyOverlay.MainSceneContainer,
        paddingTop: isNotStandaloneMobilePWA ? (windowHeight < 650 ? '4.8rem' : '4.5rem') : pwaStyleAdapter(4.5, 'rem'),
      },
    PinnedPanelContainer: {
      ...defaultTheme.LobbyOverlay.PinnedPanelContainer,
      paddingBottom: isMobile ? '4rem' : '1rem',
    },
  },
  DailySpin: {
    ...defaultTheme.DailySpin,
    MileStoneRowLoyaltyIcon: {
      ...defaultTheme.DailySpin.MileStoneRowLoyaltyIcon,
      height: 32,
      width: 32,
      marginBottom: 5,
    },
    DaysStreakContainerSmallScreen: {
      ...defaultTheme.DailySpin.DaysStreakContainerSmallScreen,
      margin: isTablet && windowWidth > 1150 ? '0 1rem 0 1rem' : '0 1rem 0.5rem 1rem',
      padding: isTablet
        ? windowWidth > 1150
          ? '0px 1rem 0.5rem 1rem'
          : '0px 1rem 1rem 1rem'
        : '0rem 1rem 0.5rem 1rem',
    },
    StreakColumnWrapper: {
      ...defaultTheme.DailySpin.StreakColumnWrapper,
      bottom: isNotStandaloneMobilePWA ? '0.5rem' : 'auto',
      height: isTablet
        ? isStandalonePWA
          ? '85%'
          : windowWidth > 1150
            ? '95%'
            : '90%'
        : windowHeight < 380
          ? '100%'
          : '98%',
    },
    mileStoneRowCoinIcon: {
      ...defaultTheme.DailySpin.mileStoneRowCoinIcon,
      marginBottom: 4,
    },
    MilestoneCircleImage: {
      ...defaultTheme.DailySpin.MilestoneCircleImage,
      top: isTablet && isStandalonePWA ? -7 : windowHeight < 800 ? -10 : -20,
    },
    MilestoneCoinsValue: {
      ...defaultTheme.DailySpin.MilestoneCoinsValue,
      marginBottom: 0,
    },
    MilestoneRowContainer: {
      ...defaultTheme.DailySpin.MilestoneRowContainer,
      marginTop: windowWidth > 1800 && windowHeight > 1050 ? 5 : 0,
    },
    RegDaysItemLoyaltyIcon: {
      ...defaultTheme.DailySpin.RegDaysItemLoyaltyIcon,
      height: 20,
      width: 20,
    },
  },
  SocialHeaderTab: {
    ...defaultTheme.SocialHeaderTab,
    BackgroundImage: {
      ...defaultTheme.SocialHeaderTab.BackgroundImage,
      bottom: '0.25rem',
    },
  },
  CoinItem: {
    ...defaultTheme.CoinItem,
    LoyaltyIconCapWithBadge: {
      ...defaultTheme.CoinItem.LoyaltyIconCapWithBadge,
      height: '95%',
    },
  },
  MissionHelp: {
    ...defaultTheme.MissionHelp,
    ModalStyle: {
      ...defaultTheme.MissionHelp.ModalStyle,
      padding:
        isNotStandaloneMobilePWA && !isTablet
          ? '9vh 16vw 0'
          : isStandalonePWA && !isTablet
            ? '13vh 16vw 0'
            : '6vh 16vw 0',
      zIndex: '100',
    },
  },
  PurchaseFlow: {
    ...defaultTheme.PurchaseFlow,
    billingProfileSelect: {
      ...defaultTheme.PurchaseFlow.billingProfileSelect,
      border: '1px solid rgb(255, 65, 229)',
      outline: 'none',
      background: theme.palette.primary[32],
    },
    PaymentInfoFields: {
      ...defaultTheme.PurchaseFlow.PaymentInfoFields,
      border: '1px solid rgb(255, 65, 229)',
      outline: 'none',
      background: theme.palette.primary[32],
    },
    creditCardField: {
      ...defaultTheme.PurchaseFlow.creditCardField,
      border: '1px solid rgb(255, 65, 229)',
      background: theme.palette.primary[32],
    },
    DownArrowIcon: {
      ...defaultTheme.PurchaseFlow.DownArrowIcon,
      position: 'absolute',
      right: '1.5rem',
      cursor: 'pointer',
      pointerEvents: 'none',
      bottom: isMobile && !isTablet ? '1.8rem' : '1.3rem',
    },
    CreditCardDetailDownArrowIcon: {
      ...defaultTheme.PurchaseFlow.CreditCardDetailDownArrowIcon,
      position: 'absolute',
      right: '1.5rem',
      cursor: 'pointer',
      pointerEvents: 'none',
      bottom: isTablet ? '1.5rem' : isMobile ? '2.2rem' : '2rem',
    },
    BillingProfileDownArrowIcon: {
      ...defaultTheme.PurchaseFlow.BillingProfileDownArrowIcon,
      position: 'absolute',
      right: '1.5rem',
      cursor: 'pointer',
      pointerEvents: 'none',
      bottom: isTablet ? '1.3rem' : isMobile ? '1.4rem' : '1rem',
    },
  },
  NavigationBar: {
    ...defaultTheme.NavigationBar,
    BarSection: {
      ...defaultTheme.NavigationBar.BarSection,
      paddingBottom: '1.5rem',
    },
    LoyaltyCurrencyWrapperStyle: {
      ...defaultTheme.NavigationBar.LoyaltyCurrencyWrapperStyle,
      position: 'absolute',
      right: windowWidth < 1300 ? 'calc(50% - 200px)' : 'calc(50% - 205px)',
    },
    TopBar: {
      ...defaultTheme.NavigationBar.TopBar,
      height: '5.7rem',
    },
    DealTimerText: {
      ...defaultTheme.NavigationBar.DealTimerText,
      color: '#6D1337',
      top: '-1.25rem',
    },
    HomeIcon: {
      ...defaultTheme.NavigationBar.HomeIcon,
      height: 58,
      width: 58,
      marginTop: 3,
    },
    CoinsCurrencyContainer: {
      ...defaultTheme.NavigationBar.CoinsCurrencyContainer,
      marginRight: '1.5%',
    },
    SettingIcon: {
      ...defaultTheme.NavigationBar.SettingIcon,
      width: 70,
      height: 70,
    },
    DealSplittedTextGradient: {
      ...defaultTheme.NavigationBar.DealSplittedTextGradient,
      ...(isMobile && !isTablet && { marginTop: 1 }),
    },
  },
  VideoAds: {
    ...defaultTheme.VideoAds,
    CloseText: {
      ...defaultTheme.VideoAds.CloseText,
      fontSize: '16px',
    },
    KeepWatchingText: {
      ...defaultTheme.VideoAds.KeepWatchingText,
      fontSize: '16px',
    },
  },
  WatchAndEarnInfo: {
    ...defaultTheme.WatchAndEarnInfo,
    TimeRemainingText: {
      ...defaultTheme.WatchAndEarnInfo.TimeRemainingText,
      textShadow: 'none',
      fontWeight: 600,
      marginLeft: '1rem',
    },
  },
  Bar: {
    ...defaultTheme.Bar,
    BarContainer: {
      ...defaultTheme.Bar.BarContainer,
      background: '#32003b',
    },
    BarProgress: {
      ...defaultTheme.Bar.BarProgress,
      background: '#0080ca',
    },
    BarText: {
      ...defaultTheme.Bar.BarText,
      marginLeft: 'auto',
    },
  },
  Tier: {
    ...defaultTheme.Tier,
    Card: {
      ...defaultTheme.Tier.Card,
      width: 75,
    },
    TierWrapperMissionInProgress: {
      ...defaultTheme.Tier.TierWrapperMissionInProgress,
      marginRight: isTablet ? (windowWidth > 1150 ? '70px !important' : '6.5vw !important') : '5.5vw !important',
    },
    TierWrapper: {
      ...defaultTheme.Tier.TierWrapper,
      marginRight: windowWidth < 1400 ? '80px !important' : windowWidth < 1700 ? '90px !important' : '110px !important',
    },
  },
  VipAccessFlow: {
    ...defaultTheme.VipAccessFlow,
    VipAccessButtonText: {
      ...defaultTheme.VipAccessFlow.VipAccessButtonText,
      fontWeight: 800,
      paddingBottom: '1%',
    },
    VipAccessButtonImage: {
      ...defaultTheme.VipAccessFlow.VipAccessButtonImage,
      width: 210,
    },
    VipAccessRedeemButtonText: {
      ...defaultTheme.VipAccessFlow.VipAccessRedeemButtonText,
      fontWeight: 800,
      color: theme.palette.common[42],
      paddingBottom: '1%',
    },
  },
  OutOfCoin: {
    ...defaultTheme.OutOfCoin,
    QuickBuyOfferDetails: {
      ...defaultTheme.OutOfCoin.QuickBuyOfferDetails,
      bottom: windowHeight > 1200 ? '12.5%' : '15.5%',
    },
  },
  DefaultTooltip: {
    ...defaultTheme.DefaultTooltip,
    Border: {
      ...defaultTheme.DefaultTooltip.Border,
      stopColor1: '#FFBF02',
      stopColor2: '#F49902',
    },
    Background: {
      ...defaultTheme.DefaultTooltip.Background,
      stopColor1: '#d636d8',
      stopColor2: '#32003b',
    },
  },
  SmartBanner: {
    ...defaultTheme.SmartBanner,
    LogoButtonStyle: {
      ...defaultTheme.SmartBanner.LogoButtonStyle,
      height: '150%',
      bottom: '30%',
      left: '-30%',
    },
  },
  BonusLinkMessage: {
    ...defaultTheme.BonusLinkMessage,
    PromoImage: {
      ...defaultTheme.BonusLinkMessage.PromoImage,
      paddingTop: '376px',
    },
    BonusLinkButton: {
      ...defaultTheme.BonusLinkMessage.BonusLinkButton,
      textShadow: `1px 1px 0px ${theme.palette.secondary[0]}, 1px -1px 0px ${theme.palette.secondary[0]}, -1px 1px 0px ${theme.palette.secondary[0]}, -1px -1px 0px ${theme.palette.secondary[0]}`,
    },
    CoinsBonusContainer: {
      ...defaultTheme.BonusLinkMessage.CoinsBonusContainer,
      bottom: isTablet ? '-3.9rem' : isMobile ? '-4.1rem' : '-3.85rem',
    },
    LPBonusContainer: {
      ...defaultTheme.BonusLinkMessage.LPBonusContainer,
      bottom: '-2.35rem',
    },
    LoyaltyIcon: {
      ...defaultTheme.BonusLinkMessage.LoyaltyIcon,
      marginRight: 10,
    },
  },
  OfferDetail: {
    ...defaultTheme.OfferDetail,
    PurchaseResponseHighlightHeader: {
      ...defaultTheme.OfferDetail.PurchaseResponseHighlightHeader,
      fontWeight: '600',
    },
    PurchaseResponseHeader: {
      ...defaultTheme.OfferDetail.PurchaseResponseHeader,
      fontWeight: '600',
    },
    RewardCenterPurchaseResponseMessage: {
      ...defaultTheme.OfferDetail.RewardCenterPurchaseResponseMessage,
      fontSize: '1em',
    },
    ExclamationIcon: {
      ...defaultTheme.OfferDetail.ExclamationIcon,
      width: 126,
      height: 'auto',
    },
    CarouselIndicator: {
      ...defaultTheme.OfferDetail.CarouselIndicator,
      backgroundColor: '#32003B',
      border: `3px solid #32003B`,
    },
    CarouselIndicatorActive: {
      ...defaultTheme.OfferDetail.CarouselIndicatorActive,
      backgroundColor: '#BE00DF',
      border: `3px solid #FFAF03`,
    },
  },
  LinkAccountForm: {
    ...defaultTheme.LinkAccountForm,
    ScreenBackground: {
      backgroundImage: `url(${assetSource(ASSET_KEY.LIGHT_DIVIDER)})`,
      backgroundSize: '80%',
      backgroundRepeat: 'no-repeat',
      backgroundPositionX: 'center',
      backgroundPositionY: 31,
    },
    HeaderTitle: {
      ...defaultTheme.LinkAccountForm.HeaderTitle,
      fontSize: '1.4rem',
      margin: 4,
    },
    NeedHelpText: {
      ...defaultTheme.LinkAccountForm.NeedHelpText,
      right: '1.5rem',
    },
    FormInput: {
      ...defaultTheme.LinkAccountForm.FormInput,
      background: theme.palette.primary[32],
      borderRadius: '0.6em',
      boxShadow: 'none',
      border: '1px solid transparent',
    },
  },
  LinkAccount: {
    ...defaultTheme.LinkAccount,
    LinkAccountTitle: {
      ...defaultTheme.LinkAccount.LinkAccountTitle,
      paddingTop: '0.5rem',
    },
  },
  VIPItem: {
    ...defaultTheme.VIPItem,
    VipPackageContainer: {
      ...defaultTheme.VIPItem.VipPackageContainer,
      background: `
      linear-gradient(145deg, #4d085a, #590B69) padding-box,
      linear-gradient(145deg, #d240d4, #6d0c80, #980bb1) border-box
    `,
      backgroundOrigin: 'border-box',
      backgroundClip: 'padding-box, border-box',
    },
    LogoImage: {
      ...defaultTheme.VIPItem.LogoImage,
      width: windowWidth > 1500 ? 250 : 200,
    },
    Divider: {
      ...defaultTheme.VIPItem.Divider,
      background: 'linear-gradient(to right, transparent, rgba(0, 0, 0, 0.7), transparent)',
    },
  },
  Settings: {
    ...defaultTheme.Settings,
    BackgroundLightDivider: {
      ...defaultTheme.Settings.BackgroundLightDivider,
      backgroundImage: `url(${assetSource(ASSET_KEY.LIGHT_DIVIDER)})`,
      backgroundSize: '80%',
      backgroundRepeat: 'no-repeat',
      backgroundPositionX: 'center',
      backgroundPositionY: 31,
    },
    HeaderImage: {
      ...defaultTheme.Settings.HeaderImage,
      height: '4.7rem',
    },
    BackArrowContainer: {
      ...defaultTheme.Settings.BackArrowContainer,
      top: '1.5rem',
    },
  },
  WelcomeBonus: {
    ...defaultTheme.WelcomeBonus,
    OfferDetails: {
      ...defaultTheme.WelcomeBonus.OfferDetails,
      bottom: '19.4%',
      left: '-2%',
    },
  },
  Wheel: {
    ...defaultTheme.Wheel,
    Amount: {
      ...defaultTheme.Wheel.Amount,
      color: theme.palette.common[1],
      textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
    },
  },
  ResetPassword: {
    ...defaultTheme.ResetPassword,
    FormInputsFields: {
      ...defaultTheme.ResetPassword.FormInputsFields,
      background: theme.palette.primary[32],
      borderRadius: '0.6em',
      outline: 'none',
      boxShadow: 'none',
    },
    InputLabel: {
      ...defaultTheme.ResetPassword.InputLabel,
      color: theme.palette.common[1],
    },
    ModalStyle: {
      ...defaultTheme.ResetPassword.ModalStyle,
      padding: window.innerWidth < 1400 ? '0 40vmin' : '0 44vmin',
    },
  },
  SignUp: {
    ...defaultTheme.SignUp,
    FormInputTheme: {
      ...defaultTheme.SignUp.FormInputTheme,
      background: theme.palette.primary[32],
      borderRadius: '0.6em',
      outline: 'none',
      boxShadow: 'none',
    },
    MultipleInputInRowWrapper: {
      ...defaultTheme.SignUp.MultipleInputInRowWrapper,
      width: '49%',
    },
    TermsLink: {
      ...defaultTheme.SignUp.TermsLink,
      color: theme.palette.primary[9],
    },
    NeedHelpLink: {
      ...defaultTheme.SignUp.NeedHelpLink,
      color: theme.palette.primary[9],
    },
    CheckBox: {
      ...defaultTheme.SignUp.CheckBox,
      height: isMobile ? 30 : 20,
    },
  },
  TermsModal: {
    ...defaultTheme.TermsModal,
    TermsLinkText: {
      ...defaultTheme.TermsModal,
      color: '#6cb6e5',
    },
    TermsBodyText: {
      fontSize: !isMobile ? '1.2rem' : '1.5rem',
    },
    TermsFooterText: {
      fontSize: '1.3rem',
    },
    TermsCheckboxFooter: {
      width: '25px !important',
      height: '25px !important',
    },
  },
  TermsModalWrapper: {
    ...defaultTheme.TermsModalWrapper,
    NeedHelpLink: {
      ...defaultTheme.TermsModalWrapper.NeedHelpLink,
      color: theme.palette.primary[9],
    },
    Modal: {
      ...defaultTheme.TermsModalWrapper.Modal,
      padding:
        isStandalonePWA && !isTablet
          ? '0 25vmin !important'
          : windowWidth < 700
            ? '0 4vmin !important'
            : windowWidth < 1600
              ? '0 20vmin !important'
              : windowWidth < 1900
                ? '0 30vmin !important'
                : '0 50vmin !important',
    },
    HeaderImage: {
      ...defaultTheme.TermsModalWrapper.HeaderImage,
      width: isTablet ? 'calc(100% + 7px)' : '100%',
      left: isTablet ? -3 : 0,
    },
  },
  GameUnavailable: {
    ...defaultTheme.GameUnavailable,
    ButtonText: {
      ...defaultTheme.GameUnavailable.ButtonText,
      paddingTop: '0px',
    },
  },
  BottomBar: {
    ...defaultTheme.BottomBar,
    Divider: {
      ...defaultTheme.BottomBar.Divider,
      bottom: -10,
    },
    BottomBarBackground: {
      ...defaultTheme.BottomBar.BottomBarBackground,
      height: isMobile && !isTablet ? '5.5rem' : '7rem',
    },
    WatchAndEarnIcon: {
      ...defaultTheme.BottomBar.WatchAndEarnIcon,
      height: '7.5em',
      marginBottom: isMobile && !isTablet ? '-5em' : '-3em',
    },
    MailIcon: {
      ...defaultTheme.BottomBar.MailIcon,
      height: '7.5em',
      marginBottom: isMobile && !isTablet ? '-5em' : '-3em',
    },
    SlotsIcon: {
      ...defaultTheme.BottomBar.SlotsIcon,
      height: '7.5em',
      marginBottom: isMobile && !isTablet ? '-5.1em' : '-3.1em',
    },
    VIPIcon: {
      ...defaultTheme.BottomBar.VIPIcon,
      height: '8.5em',
      marginBottom: isMobile && !isTablet ? '-5.8em' : '-3.8em',
    },
    RewardCenterIcon: {
      ...defaultTheme.BottomBar.SlotsIcon,
      height: '10em',
      marginBottom: isMobile && !isTablet ? '-6em' : '-3.8em',
    },
    MissionsIcon: {
      height: '8em',
      marginBottom: isMobile && !isTablet ? '-5.2em' : '-3.2em',
    },
    BarItemIcon: {
      ...defaultTheme.BottomBar.BarItemIcon,
      height: '8em',
      marginBottom: isMobile && !isTablet ? '-5.25em' : '-3.25em',
    },
    ChestOpenBarIcon: {
      ...defaultTheme.BottomBar.ChestOpenBarIcon,
      left: isMobile && !isTablet ? '1em' : '0.5em',
      marginBottom: isTablet ? (isStandalonePWA ? '0.9rem' : 0) : isMobile ? '-0.7rem' : 0,
    },
    ChestClosedBarIcon: {
      ...defaultTheme.BottomBar.ChestClosedBarIcon,
      left: isMobile && !isTablet ? '1em' : '0.5em',
      marginBottom: isTablet ? (isStandalonePWA ? '0.9rem' : 0) : isMobile ? '-0.7rem' : 0,
    },
    TimerLabel: {
      ...defaultTheme.BottomBar.TimerLabel,
      position: 'relative',
      bottom: 0,
      paddingLeft: isTablet ? '18%' : isMobile ? '20%' : '18%',
      marginBottom: isTablet ? '-11.8%' : isMobile ? '-8.5%' : '-13.5%',
    },
    TimerWrapper: {
      ...defaultTheme.BottomBar.TimerWrapper,
      height: '70%',
      width: isMobile && !isTablet ? '105%' : '115%',
      left: isMobile && !isTablet ? '0.2rem' : '-0.5rem',
      bottom: isStandalonePWA && isTablet ? '-0.05em' : isMobile ? (isTablet ? '-0.1em' : '-0.8em') : '-0.15em',
    },
    TimerBackground: {
      ...defaultTheme.BottomBar.TimerBackground,
      height: '100%',
      objectFit: 'contain',
      bottom: '-0.5em',
    },
    BarChestItem: {
      ...defaultTheme.BottomBar.BarChestItem,
      marginLeft: isMobile ? (isTablet ? '1rem' : '3rem') : '2.5rem',
      marginRight: isMobile ? (isTablet ? '2rem' : '2rem') : '2.5rem',
    },
  },
  GameTile: {
    ...defaultTheme.GameTile,
    SneakPeekTimerText: {
      ...defaultTheme.GameTile.SneakPeekTimerText,
      marginTop: '0.1rem',
    },
  },
  StoreDownload: {
    ...defaultTheme.StoreDownload,
    Container: {
      ...defaultTheme.StoreDownload.Container,
      backgroundColor: 'black',
    },
  },
  RewardCenter: {
    ...defaultTheme.RewardCenter,
    RewardCenterMainContentHolder: {
      ...defaultTheme.RewardCenter.RewardCenterMainContentHolder,
      paddingLeft: '5px',
      paddingRight: '5px',
    },
    ProfileFooterLink: {
      ...defaultTheme.RewardCenter.ProfileFooterLink,
      color: theme.palette.primary[9],
    },
  },
  CreditCardDetails: {
    ...defaultTheme.CreditCardDetails,
    CheckBoxBackgroundImage: {
      ...defaultTheme.CreditCardDetails.CheckBoxBackgroundImage,
      width: '40%',
    },
  },
  Start: {
    ...defaultTheme.Start,
    Logo: {
      ...defaultTheme.Start.Logo,
      marginTop: windowHeight > 700 ? '6%' : '0px',
    },
    MainContentContainer: {
      ...defaultTheme.Start.MainContentContainer,
      marginTop: windowHeight > 700 ? 30 : -20,
    },
    BottomBarFooterText: {
      ...defaultTheme.Start.BottomBarFooterText,
      marginTop: 10,
      textShadow: '2px 2px 2px #000000',
    },
    MiddleLayoutButtonContainer: {
      ...defaultTheme.Start.MiddleLayoutButtonContainer,
      marginTop: isNotStandaloneMobilePWA ? '12rem' : '4rem',
    },
    ComingSoonBackgrounds: {
      ...defaultTheme.Start.ComingSoonBackgrounds,
      backgroundPosition: 'center 60%, center',
    },
    ComingSoonBackgroundsMobile: {
      ...defaultTheme.Start.ComingSoonBackgroundsMobile,
      backgroundPosition: windowWidth > windowHeight ? 'center 65%, 50%' : 'center 50%, 50%',
    },
    MiddleSectionWrapper: {
      ...defaultTheme.Start.MiddleSectionWrapper,
      paddingInlineStart: '0rem',
    },
  },
  ShopScreen: {
    ...defaultTheme.ShopScreen,
    ShopContainer: {
      ...defaultTheme.ShopScreen.ShopContainer,
      PackagesContainer: {
        ...defaultTheme.ShopScreen.ShopContainer.PackagesContainer,
        padding: '6% 5.5rem 0.4rem',
        CoinItem: {
          ...defaultTheme.ShopScreen.ShopContainer.PackagesContainer.CoinItem,
          left: '2px',
        },
        InnerItem: {
          ...defaultTheme.ShopScreen.ShopContainer.PackagesContainer.InnerItem,
          StackLoyaltyIcon: {
            ...defaultTheme.ShopScreen.ShopContainer.PackagesContainer.InnerItem.StackLoyaltyIcon,
            width: 35,
            position: 'relative',
            top: '0.2rem',
          },
        },
      },
    },
  },
  MissionsProgress: {
    ...defaultTheme.MissionsProgress,
    MissionIcon: {
      ...defaultTheme.MissionsProgress.MissionIcon,
      ...(isMobile && { top: '-0.8rem' }),
    },
    RankContainer: {
      ...defaultTheme.MissionsProgress.RankContainer,
      ...(isMobile && { top: '-0.8rem' }),
    },
    RankContainerWithNoCard: {
      ...defaultTheme.MissionsProgress.RankContainerWithNoCard,
      ...(isMobile && { top: '-0.8rem' }),
      right: windowWidth < 1400 ? 'calc(50% + 45px)' : 'calc(50% + 40px)',
    },
    TimeText: {
      ...defaultTheme.MissionsProgress.TimeText,
      fontSize: 19,
    },
    BarLabel: {
      ...defaultTheme.MissionsProgress.BarLabel,
      letterSpacing: isMobile && !isAndroid ? 0.2 : -1,
      left: isMobile ? '0.5vw' : '0.3vw',
      bottom: -1,
    },
    ProgressBarRankText: {
      ...defaultTheme.MissionsProgress.ProgressBarRankText,
      fontWeight: 800,
      letterSpacing: 2,
      left: '0.2vw',
      ...(isMobile && {
        fontSize: '1.8vw',
        top: '0.6vh',
      }),
    },
  },
  BattleProgressTooltip: {
    ...defaultTheme.BattleProgressTooltip,
    Title: {
      ...defaultTheme.BattleProgressTooltip.Title,
        textShadow: '1px 1px 1px #6A007D',
      },
    LeaderboardHeader: {
    ...defaultTheme.BattleProgressTooltip.LeaderboardHeader,
      textShadow: '1px 1px 1px #6A007D',
    },
  },
  BattlesGoal: {
    ...defaultTheme.BattlesGoal,
    InfoText: {
    ...defaultTheme.BattlesGoal.InfoText,
      textShadow: '0px 2px 0px #6A007D',
    },
    Amount: {
    ...defaultTheme.BattlesGoal.Amount,
      textShadow: '0px 3px 0px #6A007D',
    },
  },
  BattlesRankingTable: {
    ...defaultTheme.BattlesRankingTable,
    TableHeaderItem: {
    ...defaultTheme.BattlesRankingTable.TableHeaderItem,
      textShadow: '0px 3px 0px #6A007D',
    },
  },
  BattlesReward: {
    ...defaultTheme.BattlesReward,
    InfoText: {
    ...defaultTheme.BattlesReward.InfoText,
      textShadow: '0px 3px 0px #6A007D',
    },
    InfoAmountContainer: {
    ...defaultTheme.BattlesReward.InfoAmountContainer,
      textShadow: '0px 3px 0px #6A007D',
    },
    Amount: {
    ...defaultTheme.BattlesReward.Amount,
      textShadow: '0px 3px 0px #6A007D',
    },
  },
  BattlesTabsScreen: {
    ...defaultTheme.BattlesTabsScreen,
    InfoText: {
    ...defaultTheme.BattlesTabsScreen.InfoText,
      textShadow: '0px 3px 0px #550063',
    },
  },
  CurrencyDisplay: {
    ...defaultTheme.CurrencyDisplay,
    Icons: {
      ...defaultTheme.CurrencyDisplay.Icons,
      loyalty: {
        ...defaultTheme.CurrencyDisplay.Icons.loyalty,
        left: -25,
      },
    },
    LoyaltyLabel: {
      ...defaultTheme.CurrencyDisplay.LoyaltyLabel,
      paddingLeft: 20,
    },
  },
  ForgotPassword: {
    ...defaultTheme.ForgotPassword,
    ModalContainer: {
      ...defaultTheme.ForgotPassword.ModalContainer,
      height: '45vh',
      minHeight: '300px',
    },
    ModalBody: {
      ...defaultTheme.ForgotPassword.ModalBody,
      justifyContent: 'center',
    },
  },
  TimeRemaining: {
    ...defaultTheme.TimeRemaining,
    VIPTimer: {
      ...defaultTheme.TimeRemaining.VIPTimer,
      top: pwaStyleAdapter(5, 'rem'),
    },
    TimerLabel: {
      ...defaultTheme.TimeRemaining.TimerLabel,
      color: theme.palette.common[1],
    },
  },
  Login: {
    ...defaultTheme.Login,
    ModalContainer: {
      ...defaultTheme.Login.ModalContainer,
      height: isNotStandaloneMobilePWA ? '55vh' : '45vh',
    },
    ModalStyle: {
      ...defaultTheme.Login.ModalStyle,
      paddingBottom: isNotStandaloneMobilePWA ? (windowHeight < 320 ? '20vh' : '12vh') : 0,
    },
    ForgetPasswordLink: {
      ...defaultTheme.Login.ForgetPasswordLink,
      textAlign: 'end',
      marginLeft: 0,
      marginRight: '0.8rem',
    },
  },
  SideBar: {
    ...defaultTheme.SideBar,
    MenuItem: {
      ...defaultTheme.SideBar.MenuItem,
      padding: `0 0 0 ${isMobile && !isTablet ? 7.5 : windowWidth < 1400 ? 2 : 3.5}rem`,
    },
    MenuContainer: {
      ...defaultTheme.SideBar.MenuContainer,
      border: '5px solid #A71FCD',
      background: 'linear-gradient(to bottom, #0b0213 0%, #330058 25%, #50008a 50%, #330058 75%, #0b0213 100%)',
    },
  },
  BillingProfile: {
    ...defaultTheme.BillingProfile,
    AddDeleteProfileText: {
      ...defaultTheme.BillingProfile.AddDeleteProfileText,
      border: '2px solid rgb(108, 182, 229)',
    },
  },
  MessageList: {
    ...defaultTheme.MessageList,
    ScrollBarCustomStyle: {
      ...defaultTheme.MessageList.ScrollBarCustomStyle,
      height: '100%',
    },
  },
  MessageContainer: {
    ...defaultTheme.MessageContainer,
    TitleText: {
      ...defaultTheme.MessageContainer.TitleText,
      textStroke: '2px #350041',
      WebkitTextStroke: '2px #350041',
    },
  },
  OfferDetailDescription: {
    ...defaultTheme.OfferDetailDescription,
    ButtonIcon: {
      ...defaultTheme.OfferDetailDescription.ButtonIcon,
      width: '3.5em',
      marginBottom: 3,
      marginLeft: -5,
    },
    ButtonText: {
      ...defaultTheme.OfferDetailDescription.ButtonText,
      paddingBottom: '2%',
      fontSize: 32,
    },
  },
  FavouritesInformation: {
    ...defaultTheme.FavouritesInformation,
    LevelUpText: {
      ...defaultTheme.FavouritesInformation.LevelUpText,
      fontWeight: 600,
      textTransform: 'uppercase',
    },
  },
  BrowserScreen: {
    ...defaultTheme.BrowserScreen,
    DescriptionWrap: {
      ...defaultTheme.BrowserScreen.DescriptionWrap,
      marginTop: 0,
    },
    ButtonContainer: {
      ...defaultTheme.BrowserScreen.ButtonContainer,
      marginTop: '5vh',
    },
  },
};

export default LadyluckTheme;

